import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import { seuilsGlobalInitialState, SeuilsGlobalStateProps, seuilsGlobalStateStore } from './seuils-global.store';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SeuilsGlobalRepository extends BaseStoreRepository<SeuilsGlobalStateProps> {
  constructor() {
    super(seuilsGlobalStateStore.pipe(select(state => state)), seuilsGlobalStateStore, seuilsGlobalInitialState);
  }
}
